// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Content/Blogview.jsx

import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import ToastNotification from '../ToastNotification';
import BlogForm from './BlogForm';
import '../../css/InternetHeaderView.scss';
import { deleteContentBlog } from '../../utils/ExploreBlogHandlers';

const IdeasLabView = ({
  headers,
  setHeaders,
  totalCount,
  searchQuery,
  pageLength,
  currentPage,
  setCurrentPage,
  handlePageLengthChange,
  refreshData,
}) => {
  const [editingRows, setEditingRows] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [formMode, setFormMode] = useState('add');
  const [selectedIdea, setSelectedIdea] = useState(null);

  const first = (currentPage - 1) * pageLength;

  const showToastMessage = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
  };

  const refresh = () => {
    if (shouldRefresh) {
      refreshData();
      setShouldRefresh(false);
    }
  };

  const textEditor = (options) => (
    <InputText
      type="text"
      value={options.value || ''}
      onChange={(e) => options.editorCallback(e.target.value)}
      style={{ width: '100%' }}
    />
  );

  const onRowEditInit = (e) => {
    setFormMode('edit');
    setSelectedIdea(e.data); // ส่งข้อมูลแถวที่เลือกไปที่ฟอร์ม   
    setShowForm(true); // เปิดฟอร์มทันที
  };

  const deleteActionTemplate = (rowData) => (
    <Button
      icon="pi pi-trash"
      className="p-button-danger p-button-sm"
      onClick={async () => {
        try {
          await deleteContentBlog(rowData.Home_ID);
          setHeaders((prev) => prev.filter((h) => h.Home_ID !== rowData.Home_ID));
          showToastMessage('Idea deleted successfully', 'success');
        } catch (err) {
          showToastMessage(`Error: ${err.message}`, 'error');
          setShouldRefresh(true);
        } finally {
          refresh();
        }
      }}
    />
  );

  const addIdea = () => {
    setFormMode('add');
    setSelectedIdea(null);
    setShowForm(true);
  };

  const handleFormSave = (savedIdea) => {
    if (formMode === 'add') {
      setHeaders((prev) => [...prev, savedIdea]);
      showToastMessage('Idea added successfully', 'success');
    } else {
      setHeaders((prev) =>
        prev.map((idea) => (idea.Home_ID === savedIdea.Home_ID ? savedIdea : idea))
      );
      showToastMessage(`Idea ${savedIdea.Home_ID} updated successfully`, 'success');
    }
    setShowForm(false);
  };

  const handleFormCancel = () => {
    setShowForm(false);
  };

  const totalPages = Math.ceil(totalCount / pageLength);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const paginatorTemplate = {
    layout: 'PrevPageLink PageLinks NextPageLink',
    PrevPageLink: () => (
      <button
        className={`page-link ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </button>
    ),
    NextPageLink: () => (
      <button
        className={`page-link ${currentPage === totalPages ? 'disabled' : ''}`}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    ),
    PageLinks: () => {
      const pages = [];
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            className={`page-link ${currentPage === i ? 'active' : ''}`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        );
      }
      return <span className="pagination">{pages}</span>;
    },
  };

  const categoryTemplate = (rowData) => {
    // ตรวจสอบว่า Home_Category เท่ากับ 1 (เปรียบเทียบทั้งตัวเลขและสตริง)

    if (Number(rowData.Home_Category) === 1) {
      return `News | ${rowData.Home_Category}`;
    }else if (Number(rowData.Home_Category) === 2) {
        return `Highlights | ${rowData.Home_Category}`;
    }
    
    return rowData.Home_Category;
  };


  return (
    <>
      <ToastNotification
        showToast={showToast}
        toastMessage={toastMessage}
        toastVariant={toastVariant}
        setShowToast={setShowToast}
      />

      {showForm && (
        <BlogForm
          ideaData={selectedIdea}
          mode={formMode}
          onCancel={handleFormCancel}
          onSave={handleFormSave}
        />
      )}

      {!showForm && (
        <div className="ideaslab-header-wrapper">
          <div className="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
            <Button
              icon="pi pi-plus"
              label="Add Idea"
              className="p-button-success p-button-sm"
              onClick={addIdea}
            />
            <div className="select-container me-md-2">
              <select
                id="pageLengthSelect"
                className="form-select"
                value={pageLength}
                onChange={handlePageLengthChange}
              >
                <option value="10">10 Rows</option>
                <option value="20">20 Rows</option>
                <option value="50">50 Rows</option>
              </select>
            </div>
          </div>

          <DataTable
            value={headers}
            paginator
            rows={pageLength}
            totalRecords={totalCount}
            first={first}
            editMode="row"
            dataKey="Home_ID"
            onRowEditInit={onRowEditInit} // เปลี่ยนจาก onRowEditComplete เป็น onRowEditInit
            className="p-datatable-gridlines"
            paginatorTemplate={paginatorTemplate}
            currentPageReportTemplate={`Showing page ${currentPage} of ${totalPages}`}
          >
            <Column field="Home_ID" header="ID" headerStyle={{ width: '10%' }} sortable />
           

            <Column
              field="Home_Category"
              header="Category"
              headerStyle={{ width: '10%' }}
              body={categoryTemplate}
              editor={textEditor}
              sortable
            />
             <Column field="Home_Visitors" header="Visitors" headerStyle={{ width: '10%' }} sortable />

            <Column field="Home_Sub" header="Subject" headerStyle={{ width: '50%' }} editor={textEditor} sortable />

            <Column  rowEditor header="Edit" headerStyle={{ width: '10%' }} bodyStyle={{ textAlign: 'center' }} />

            <Column
              header="Delete"
              body={deleteActionTemplate}
              headerStyle={{ width: '10%' }}
              bodyStyle={{ textAlign: 'center' }}
            />
          </DataTable>
        </div>
      )}
    </>
  );
};

export default IdeasLabView;